import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const MembershipContext = createContext(null);

export function MembershipProvider({ children }) {
  const { user } = useAuth();
  const [membership, setMembership] = useState(null); // null while loading; object otherwise
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user || user === null || user === false) return;
    setLoading(true);
    try {
      const { data } = await http.get("/payments/me");
      setMembership(data);
    } catch (e) {
      setMembership({ active: false, expires_at: null, days_remaining: 0, currency: "aud", plans: null });
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user && user.role) refresh();
    else setMembership(null);
  }, [user, refresh]);

  return (
    <MembershipContext.Provider value={{ membership, loading, refresh }}>
      {children}
    </MembershipContext.Provider>
  );
}

export function useMembership() {
  const ctx = useContext(MembershipContext);
  if (!ctx) throw new Error("useMembership must be used within MembershipProvider");
  return ctx;
}
